export const TitleH3 = {
  fontSize: "16px",
  fontWeight: "bold",
  fontFamily: "Roboto Condensed",
  letterSpacing: "normal",
  lineHeight: 1.5,
  marginTop: 4,
};
